"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginService = void 0;
class LoginService {
    constructor($q, $http, toolbox, userService) {
        this.$q = $q;
        this.$http = $http;
        this.toolbox = toolbox;
        this.userService = userService;
        this.loginUrl = 'Api/Login';
        this.logoutUrl = 'Api/Logout';
    }
    login(username, password) {
        var data = {
            username: username,
            password: password
        };
        var url = this.toolbox.createRequestUrl(this.loginUrl);
        let loginResponse;
        return this.$http.post(url, JSON.stringify(data))
            .then((response) => {
            loginResponse = response;
            return this.userService.resolveCurrentUser();
        }).then(() => {
            return loginResponse.data;
        });
    }
    logout() {
        let logoutResponse;
        let data = {
            userName: this.userService.getCurrentUser().getUserName()
        };
        return this.$http.post(this.toolbox.createRequestUrl(this.logoutUrl), JSON.stringify(data))
            .then((response) => {
            logoutResponse = response;
            return this.userService.removeCurrentUser();
        }).then(() => {
            return logoutResponse.status;
        });
    }
}
exports.LoginService = LoginService;
LoginService.$inject = ['$q', '$http', 'toolbox', 'userService'];
